(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('WineLoss', WineLoss);

	WineLoss.$inject = ['$window', 'BaseModel', 'Transaction'];

	function WineLoss($window, BaseModel, Transaction) {

		// Entity Defaults
		var defaults = $window.stampit().state({
			"type": "loss",
			"date": new Date(),
			"notes": null,
			"qty": 1
		});

		var WineLossFactory = $window.stampit().enclose(function () {

			this.getSummary = function(){
				return 'You lost ' + this.qty + ' bottle' + (this.qty > 1 ? 's' : '') + '.';
			};

			return $window.stampit.mixIn(this, BaseModel, Transaction);

		});

		return function(properties){
			return $window.stampit.compose(defaults, WineLossFactory).create(properties);
		};

	}

})();
